/* jshint ignore:start */

'use strict';

(function (window, document, $) {

	if ($('.testimonial-grid-slider').length > 0) {
		$('.testimonial-grid-slider').slick({
			autoplay: true,
			autoplaySpeed: 7000,
			vertical: true,
			arrows: false,
			dots: true,
			centerMode: true,
			adaptiveHeight: true,
			centerPadding: '0 0',
		});
	}
	
	// Deactivate this - using flexbox instead
	// if ($('.selma-grid').length > 0 && $(window).width() >= 992) {
	// 	var tallest = 0;
	// 	var tallest_item;
	// 	$('.selma-grid__main--item').each(function(i, item) {
	// 		var item = $(item).find('.grid-item__content');
	// 		if (item.outerHeight() > tallest) {
	// 			tallest_item = item;
	// 			tallest = item.outerHeight();
	// 		} 
	// 	});

	// 	$('.selma-grid__main--item').find('.grid-item__content').height(tallest);
	// }

})(window, document, jQuery);